import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-helpbutton-reports-totalvoiceabandoned-card',
  templateUrl: './helpbutton-reports-totalvoiceabandoned-card.component.html',
  styleUrls: ['./helpbutton-reports-totalvoiceabandoned-card.component.scss']
})
export class HelpbuttonReportsTotalvoiceabandonedCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
